import type { V1GateProcessMessageKey } from './v1-gate-process.en'

/** V1 gate retag + processing machine label and issue strings (Hindi), spread into hi.ts. The type forces every key in v1-gate-process.en.ts. */
export const v1GateProcessHi: Record<V1GateProcessMessageKey, string> = {
  // गेट — बिना टैग रखी बोरी या नमूने पर नया टैग (सुपरवाइज़र)
  'gate.v1.retag.tile': 'नया टैग',
  'gate.v1.retag.tileLine': '{count} रुके',
  'gate.v1.retag.waitNotice':
    '{count} बोरियाँ या नमूने नए टैग का इंतज़ार कर रहे हैं — सुपरवाइज़र को बुलाएँ',
  'gate.v1.retag.title': 'नया टैग',
  'gate.v1.retag.count': '{count} बोरी या नमूने बिना टैग रखे हैं',
  'gate.v1.retag.none': 'किसी को टैग का इंतज़ार नहीं',
  'gate.v1.retag.noneHint': 'ऑफ़िस ने जो बोरी या नमूने बिना टैग रखे, वे भेजने के बाद यहाँ दिखेंगे।',
  'gate.v1.retag.supOnly': 'नया टैग सिर्फ़ सुपरवाइज़र लगाएगा। उसका पिन पूछा जाएगा।',
  'gate.v1.retag.bag': 'बोरी · लॉट {lot}',
  'gate.v1.retag.sample': 'नमूना · लॉट {lot}',
  'gate.v1.retag.conflict': 'पुराना कोड {code} किसी और बोरी पर था',
  'gate.v1.retag.pick': 'बोरी चुनें',
  'gate.v1.retag.home': 'घर',
  'gate.v1.retag.scanTag': 'नया टैग स्कैन करें',
  'gate.v1.retag.scanSeal': 'नई सील स्कैन करें',
  'gate.v1.retag.holdTag': 'नया टैग डिब्बे में रखें',
  'gate.v1.retag.holdSeal': 'नई सील डिब्बे में रखें',
  'gate.v1.retag.tagScanned': 'टैग {code} स्कैन हुआ',
  'gate.v1.retag.sealScanned': 'सील {code} स्कैन हुई',
  'gate.v1.retag.again': 'फिर स्कैन',
  'gate.v1.retag.saveTag': 'नया टैग सेव करें',
  'gate.v1.retag.saveSeal': 'नई सील सेव करें',
  'gate.v1.retag.supReason': 'बिना टैग रखी बोरी या नमूने पर नया टैग।',
  'gate.v1.retag.saved': 'नया टैग {code} सेव हुआ',
  'gate.v1.retag.doneTitle': 'नया टैग सेव हुआ',
  'gate.v1.retag.doneLine': 'टैग {code} · अब कोई नहीं रुका',

  // प्रोसेसिंग — मशीन लेबल
  'process.v1.machineLabel.tile': 'मशीन लेबल',
  'process.v1.machineLabel.tileLine': '{count} मशीन पर लेबल नहीं',
  'process.v1.machineLabel.title': 'कौन सी मशीन?',
  'process.v1.machineLabel.pickHint': 'जिन मशीनों पर लेबल नहीं',
  'process.v1.machineLabel.pickWait': 'मशीन चुनें',
  'process.v1.machineLabel.allLabelled': 'हर मशीन पर लेबल लगा है',
  'process.v1.machineLabel.site': 'साइट {site}',
  'process.v1.machineLabel.scanTitle': 'लेबल स्कैन करें',
  'process.v1.machineLabel.scanHint': 'लेबल चिपकाएँ, डिब्बे में रखें',
  'process.v1.machineLabel.typeTitle': 'लेबल का नंबर लिखें',
  'process.v1.machineLabel.photoTitle': 'लेबल की फ़ोटो',
  'process.v1.machineLabel.machine': 'मशीन',
  'process.v1.machineLabel.label': 'लेबल',
  'process.v1.machineLabel.siteLabel': 'साइट',
  'process.v1.machineLabel.photo': 'मशीन पर लगा लेबल',
  'process.v1.machineLabel.photoHint': 'मशीन और लेबल एक फ़ोटो में',
  'process.v1.machineLabel.photoTaken': 'फ़ोटो हो गई',
  'process.v1.machineLabel.photoFailed': 'फ़ोटो सेव नहीं हुई। फिर से लें।',
  'process.v1.machineLabel.takePhoto': 'फ़ोटो लें',
  'process.v1.machineLabel.save': 'लेबल सेव करें',
  'process.v1.machineLabel.doneTitle': 'लेबल सेव हुआ',
  'process.v1.machineLabel.doneLine': 'मशीन {machine} · लेबल {code}',

  // प्रोसेसिंग — रन को बोरी देना (गोदाम वाला)
  'process.v1.issue.tile': 'रन को बोरी',
  'process.v1.issue.tileLine': '{count} काम',
  'process.v1.issue.title': 'रन को बोरी',
  'process.v1.issue.pick': 'काम चुनें',
  'process.v1.issue.home': 'घर',
  'process.v1.issue.none': 'देने को कोई बोरी नहीं',
  'process.v1.issue.noneBody':
    'हर काम ऑफ़िस देता है। नया काम देखने के लिए साइट की सूची फिर से डाउनलोड करें।',
  'process.v1.issue.lots': 'लॉट {lots}',
  'process.v1.issue.toRun': 'रन …{run} को · {step}',
  'process.v1.issue.progress': '{m} में से {n} बोरी दी',
  'process.v1.issue.lotsLabel': 'लॉट',
  'process.v1.issue.runLabel': 'रन',
  'process.v1.issue.bagsLabel': 'बोरी',
  'process.v1.issue.count': '{n} / {m}',
  'process.v1.issue.kgSoFar': 'अब तक किलो',
  'process.v1.issue.scan': 'काँटे पर बोरी: टैग स्कैन करें',
  'process.v1.issue.allIn': 'सारी बोरी दे दीं',
  'process.v1.issue.carryHint': 'हर बोरी मशीन के पास रन की बाकी बोरियों के साथ रखें।',
  'process.v1.issue.saved': 'टैग {no}: {kg} किलो दिया',
  'process.v1.issue.scanFirst': 'पहले बोरी स्कैन करें',
  'process.v1.issue.moistureMissing': 'पहले हर लॉट की नमी एक बार लिखें',
  'process.v1.issue.done': 'देना पूरा',
  'process.v1.issue.otherTask': 'दूसरे काम',
  'process.v1.issue.shortTitle': 'कुछ बोरी नहीं दीं',
  'process.v1.issue.shortConfirm': '{n} बोरी नहीं दीं। फिर भी पूरा करें?',
  'process.v1.issue.weighTitle': 'बोरी तौलें',
  'process.v1.issue.weightHint': 'काँटे पर सिर्फ़ यही बोरी · लॉट {lot}',
  'process.v1.issue.weight': 'काँटे का वज़न',
  'process.v1.issue.weightWait': 'वज़न लिखें',
  'process.v1.issue.save': 'बोरी सेव करें',
  'process.v1.issue.moistureTitle': 'नमी',
  'process.v1.issue.moisture': 'इस लॉट की नमी',
  'process.v1.issue.moistureNeeded': 'हर लॉट में एक बार ज़रूरी (सुखाने के लिए)',
  'process.v1.issue.moistureOnce': 'हर लॉट में एक बार, मीटर हो तो',
  'process.v1.issue.moistureWait': 'नमी लिखें',
  'process.v1.issue.bagTag': 'बोरी',
  'process.v1.issue.netShort': 'माल',
  'process.v1.issue.doneTitle': 'देना पूरा',
  'process.v1.issue.doneLine': 'बोरियाँ रन …{run} को दीं',
}
